<template>
  <v-card flat>
  </v-card>
</template>

<script>
export default {
  props: ['id', 'models'],
  data () {
    return {
      matrixQuery: '',
      itemQuery: '',
      selectedQMatrix: {},
      isMatrixSelected: false,
      matrixTableHeaders: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Authoritative', value: 'is_authoritative', sortable: true },
        {
          text: 'Number of Items',
          value: 'q_matrix_task_item_mappings',
          sortable: true
        },
        { text: 'Date Created', value: 'created_at', sortable: true },
        { text: 'Last Updated', value: 'updated_at', sortable: true },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      matrixItemTableHeaders: [
        { text: 'Code', value: 'code', sortable: true },
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Date Created', value: 'created_at', sortable: true },
        { text: 'Last Updated', value: 'updated_at', sortable: true },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  methods: {
    selectQMatrix (rowData) {
      this.selectedQMatrix.id = rowData.id
      this.selectedQMatrix.name = rowData.name
      this.selectedQMatrix.taskId = rowData.task_id
      this.selectedQMatrix.isAuthoritative = rowData.is_authoritative
      this.selectedQMatrix.qMatrixTaskItemMappings =
        rowData.q_matrix_task_item_mappings
      this.selectedQMatrix.createdAt = rowData.created_at
      this.selectedQMatrix.updatedAt = rowData.updated_at
      this.isMatrixSelected = true
    },
    parseTaskName (taskId) {
      const matchedTask = this.tasks.find(
        (task) => task.id === parseInt(taskId)
      )
      if (matchedTask) {
        return matchedTask.name
      }
    },
    getTaskMap (tasks) {
      return [
        ...new Set(
          tasks.map((task) => ({ name: task.name, task_id: task.id }))
        )
      ]
    },
    formatDate (dateString) {
      var options = { year: 'numeric', month: 'long', day: 'numeric' }
      const parsedDate = new Date(dateString)
      return parsedDate.toLocaleString('en-US', options)
    }
  }
}
</script>

<style scoped>
.table-background {
  background-color: #eee;
}
</style>
